import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import renderLangString from "../../languageStrings";

// REDUX
import { useSelector } from "react-redux";

// COMPONENTS
import Layout from "../layout/Layout";
import Icon from "../icons/Icon";

// GLOBALS
import AA_GLOBAL from "../../globals/globals";
import UserSection from "./UserSection";
import NavSelect from "../inputs/NavSelect";

const HeaderNav = ({ history }) => {
  const info = useSelector(state => state.app.info);
  const user = useSelector(state => state.user);
  const isMainMenuVisible = useSelector(state => state.app.isMainMenuVisible);
  const [userRoleMenu, setUserRoleMenu] = useState();
  const [selectedRoleItem, setSelectedRoleItem] = useState();

  const setTheUserRoleMenu = () => {
    const modules = info.apps[info.default_app].modules;
    const { labels, roles, role_selected } = user;

    // only display those for which a module exists
    const rolesMenu = roles.filter(r => modules[r]);

    let selectedRoleItem;
    const formattedMenu = rolesMenu.map((roleKey, index) => {
      const item = { id: index, key: roleKey, label: labels[roleKey] };
      if (roleKey === role_selected) selectedRoleItem = item;
      return item;
    });

    setUserRoleMenu(formattedMenu);
    setSelectedRoleItem(selectedRoleItem);
  };

  useEffect(() => {
    setTheUserRoleMenu();
  }, []);

  return (
    <nav className="bc12" data-name="HeaderNav" aria-label={renderLangString({ id: "$_c1" })}>
      <Layout flex spaceBetween>
        <div>{!isMainMenuVisible && <Icon iconId="globalNavLogo" addClass="__he_i" />}</div>
        {process.env.REACT_APP_DOMAIN ? (
          <span className="mainHeaderNav__domain">{process.env.REACT_APP_DOMAIN}</span>
        ) : null}
        <div className="u-alignHerizontal">
          {userRoleMenu && userRoleMenu.length > 1 && (
            <NavSelect
              options={userRoleMenu}
              blockOptions={true}
              select={[selectedRoleItem]}
              getValues={val => AA_GLOBAL.switchUserRole(val[0].key, { history })}
            />
          )}
          <UserSection hideProfile />
        </div>
      </Layout>
    </nav>
  );
};

export default withRouter(HeaderNav);
